import { definitionFactory, TStateTagValue } from '../definitionFactory';
import { onDeleteAction } from '../definitionsDeleteAction';

const TypeDefinitionLabels: {[index: string]: string} = {
  fz_214: '214-ФЗ',
};

export const saleTypeDefinition = definitionFactory({
  key: 'sost_type',
  mapper: (jsonQueryValue) => jsonQueryValue.map((value: TStateTagValue) => ({
    label: TypeDefinitionLabels[value as string],
    value,
  })),
  onDeleteAction: (value, options = {}) => {
    return onDeleteAction(value, 'sost_type', options);
  },
});
